const MAX_FREE_STRIKES = 2; // warnings allowed before termination

let _strikeCount = 0;
let _strikeLog = []; // { type, at, evidence }

export function registerStrike(type, evidence) {
  _strikeCount += 1;
  _strikeLog.push({ type, at: new Date().toISOString(), evidence });

  return {
    strikeNumber: _strikeCount,
    strikeLog: _strikeLog.slice(),
    action: _strikeCount > MAX_FREE_STRIKES ? "terminate" : "warn",
  };
}

export function resetStrikes() {
  _strikeCount = 0;
  _strikeLog = [];
}

export function getStrikeCount() {
  return _strikeCount;
}
